import axios from 'axios';

export const api = axios.create({
    baseURL: process.env.REACT_APP_PUBLIC_SISTEMA_URL 
});

let cachedToken = null;

const getGeneralToken = async () => {
    if (cachedToken) return cachedToken;

    const response = await axios.post(process.env.REACT_APP_PUBLIC_SISTEMA_URL + "/usuario/login", {
        username: process.env.REACT_APP_PUBLIC_PARAM_UNO,
        password: process.env.REACT_APP_PUBLIC_PARAM_DOS,
        empresaId: process.env.REACT_APP_PUBLIC_EMPRESA_ID
    });

    cachedToken = response.data.token;
    return cachedToken;
};

api.interceptors.request.use(
    async (config) => {

        const token = await getGeneralToken();
        if (token) {
            config.headers.token = token;
        }
        return config;
    }
);